(function () {
  const formatMoney = (cents, format) => {
    const amount = (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
    if (!format) return `${amount} €`;
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents || 0) / 100)));
  };

  const initialise = (root) => {
    if (root.dataset.coqueInitialised === 'true') return;
    root.dataset.coqueInitialised = 'true';

    const variantsNode = root.querySelector('[data-coque-variants]');
    const optionControls = Array.from(root.querySelectorAll('[data-coque-option]'));
    const variantInput = root.querySelector('[data-coque-variant-id]');
    const button = root.querySelector('[data-coque-atc]');
    const buttonLabel = root.querySelector('[data-coque-atc-label]');
    const price = root.querySelector('[data-coque-price]');
    const compare = root.querySelector('[data-coque-compare]');
    const stock = root.querySelector('[data-coque-stock]');
    const stockText = root.querySelector('[data-coque-stock-text]');
    const addToCartContainer = root.querySelector('add-to-cart-component');
    const moneyFormat = root.dataset.moneyFormat || '{{ amount }} €';
    const selectModelLabel = root.dataset.labelSelectModel || 'Choisis ton modèle';
    const addLabel = root.dataset.labelAdd || 'Ajouter au panier';
    const availabilityLabel = root.dataset.labelAvailability || 'Disponible';
    let variants = [];

    const normaliseMediaLabel = (value) =>
      String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();

    const characterMediaAliases = {
      belle: 'blossom',
      bulle: 'bubbles',
      rebelle: 'buttercup',
      blossom: 'blossom',
      bubbles: 'bubbles',
      buttercup: 'buttercup',
    };

    try {
      variants = JSON.parse(variantsNode?.textContent || '[]');
    } catch (error) {
      console.error('[MochiScreen] Variantes de coque illisibles.', error);
    }

    const activateMedia = (mediaId) => {
      if (!mediaId) return;
      root.querySelectorAll('[data-media-id]').forEach((media) => {
        const active = String(media.dataset.mediaId) === String(mediaId);
        media.hidden = !active;
        media.classList.toggle('is-active', active);
        if (!active) {
          media.querySelectorAll('video').forEach((video) => video.pause());
        }
      });
      root.querySelectorAll('[data-media-target]').forEach((thumb) => {
        const active = String(thumb.dataset.mediaTarget) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    root.querySelectorAll('[data-media-target]').forEach((thumb) => {
      thumb.addEventListener('click', () => activateMedia(thumb.dataset.mediaTarget));
    });

    const activateCharacterMedia = (character) => {
      const targetLabel = characterMediaAliases[normaliseMediaLabel(character)];
      if (!targetLabel) return null;

      const media = Array.from(root.querySelectorAll('[data-media-id]')).find((item) => {
        const imageAlt = normaliseMediaLabel(item.querySelector('img')?.getAttribute('alt'));
        return imageAlt === targetLabel;
      });

      if (!media) return null;
      activateMedia(media.dataset.mediaId);
      return media.querySelector('img')?.currentSrc || media.querySelector('img')?.src || null;
    };

    const renderVariant = () => {
      const selectedOptions = optionControls.map((control) => control.value);
      const complete = selectedOptions.every(Boolean);
      const characterMediaUrl = activateCharacterMedia(selectedOptions[0]);
      let selectedMediaUrl = characterMediaUrl;
      const variant = complete
        ? variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]))
        : null;

      variantInput.value = variant ? String(variant.id) : '';
      button.disabled = !variant || !variant.available;
      button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');

      if (!complete) {
        buttonLabel.textContent = selectModelLabel;
        stockText.textContent = availabilityLabel;
        stock?.classList.remove('is-unavailable');
      } else if (!variant || !variant.available) {
        buttonLabel.textContent = 'Indisponible';
        stockText.textContent = 'Cette combinaison est indisponible';
        stock?.classList.add('is-unavailable');
      } else {
        buttonLabel.textContent = addLabel;
        stockText.textContent = availabilityLabel;
        stock?.classList.remove('is-unavailable');
      }

      if (variant) {
        price.textContent = formatMoney(variant.price, moneyFormat);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          compare.hidden = false;
        } else {
          compare.textContent = '';
          compare.hidden = true;
        }

        const mediaId = variant.featured_media?.id || variant.featured_media_id;
        if (mediaId) activateMedia(mediaId);

        const mediaUrl = variant.featured_media?.preview_image?.src;
        if (mediaUrl) selectedMediaUrl = mediaUrl;
      }

      if (selectedMediaUrl && addToCartContainer) {
        addToCartContainer.dataset.productVariantMedia = selectedMediaUrl;
      }
    };

    optionControls.forEach((control) => control.addEventListener('change', renderVariant));
    renderVariant();

  };

  const boot = (scope = document) => {
    scope.querySelectorAll('[data-coque-product]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
